import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { IMG } from "@/lib/brand";
import { Section, PageHeader } from "@/components/common";

const INIT = { artiste: "", structure: "", evenement: "", lieu: "", ville: "", date: "", budget: "", email: "", telephone: "", informations: "", consent: false, website: "" };

export default function BookingArtist() {
  const [f, setF] = useState(INIT);
  const [loading, setLoading] = useState(false);
  const u = (k) => (e) => setF({ ...f, [k]: e.target?.value ?? e });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.consent) { toast.error("Merci d'accepter le consentement RGPD."); return; }
    setLoading(true);
    try {
      await api.post("/forms/booking", f);
      toast.success("Votre demande de booking a bien été envoyée.");
      setF(INIT);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="booking-artist-page">
      <PageHeader eyebrow="Booking" title="Réservez un artiste" subtitle="Concerts, showcases, événements : contactez-nous pour organiser une prestation." image={IMG.live} />
      <Section className="py-20 max-w-3xl">
        <form data-testid="booking-form" className="space-y-5" onSubmit={submit}>
          <input type="text" className="hidden" value={f.website} onChange={u("website")} tabIndex={-1} autoComplete="off" />
          <div className="grid sm:grid-cols-2 gap-5">
            <div><label className="label-dark">Artiste *</label><input required data-testid="bf-artiste" className="input-dark" value={f.artiste} onChange={u("artiste")} /></div>
            <div><label className="label-dark">Structure</label><input className="input-dark" value={f.structure} onChange={u("structure")} /></div>
            <div><label className="label-dark">Événement *</label><input required data-testid="bf-evenement" className="input-dark" value={f.evenement} onChange={u("evenement")} /></div>
            <div><label className="label-dark">Lieu</label><input className="input-dark" value={f.lieu} onChange={u("lieu")} /></div>
            <div><label className="label-dark">Ville</label><input className="input-dark" value={f.ville} onChange={u("ville")} /></div>
            <div><label className="label-dark">Date</label><input type="date" className="input-dark" value={f.date} onChange={u("date")} /></div>
            <div><label className="label-dark">Budget</label><input className="input-dark" value={f.budget} onChange={u("budget")} /></div>
            <div><label className="label-dark">Email *</label><input required type="email" data-testid="bf-email" className="input-dark" value={f.email} onChange={u("email")} /></div>
            <div><label className="label-dark">Téléphone *</label><input required data-testid="bf-telephone" className="input-dark" value={f.telephone} onChange={u("telephone")} /></div>
          </div>
          <div><label className="label-dark">Informations supplémentaires</label><textarea rows={4} className="input-dark" value={f.informations} onChange={u("informations")} /></div>
          <label className="flex items-start gap-3 text-xs text-slate-400 cursor-pointer">
            <input type="checkbox" data-testid="bf-consent" checked={f.consent} onChange={(e) => setF({ ...f, consent: e.target.checked })} className="mt-0.5 accent-amber-400 w-4 h-4" />
            <span>J'accepte que mes données soient utilisées pour traiter ma demande (RGPD).</span>
          </label>
          <button disabled={loading} data-testid="booking-submit" className="btn-gold">{loading ? "Envoi…" : "Envoyer la demande de booking"}</button>
        </form>
      </Section>
    </div>
  );
}
